import React, { useState, useEffect} from 'react'
import './screen.css'

export default function UserWindow() {
  const [outgoingmsg, setOutgoingmsg] = useState('');
  const [incomingmsg, setIncomingmsg] = useState('');
  const [ws, setWs] = useState(null)

  useEffect(() =>{
    const websocket = new WebSocket('ws://localhost:4000')
    setWs(websocket)
    websocket.addEventListener('message', handleMessage)
  }, [])

  const handleMessage = (e) =>{
    // console.log('new message', e)
  }

//   width = screenSize.dynamicWidth;

  const handleonChange = (e) => {
    setIncomingmsg(e.target.value)
  }

  return (
    <div className='contn'>
      <input id='income' placeholder='Incoming' value={outgoingmsg} onChange={handleonChange}/>
      <input id='income' placeholder='Outgoing' value={incomingmsg} onChange={handleonChange}/>
    </div>
  )
}